import React, { ReactElement } from 'react';
import {
  TableCellContainerKey,
  TableCellContainerValue,
  TableMobileContainer,
  TableRowContainer
} from './TableMobile.style';

export interface TableMobileRow {
  key: string;
  value: string | string[];
  transformValue?(arg: string | string[]): string | string[];
}

interface TableMobileProps {
  data: TableMobileRow[];
}

interface IRenderValueOptions {
  transformValue?(arg: string | string[]): string | string[];
}

const TableMobile: React.FC<TableMobileProps> = (props) => {
  const { data } = props;

  const renderValue = (value: string | string[], option?: IRenderValueOptions): ReactElement => {
    let val = value;

    if (option) {
      const { transformValue } = option;
      if (typeof transformValue === 'function') {
        val = transformValue(value);
      }
    }

    if (Array.isArray(val)) {
      return (
        <>
          {val.map((item, key) => (
            <div key={key}>{item}</div>
          ))}
        </>
      );
    }

    return <div>{val}</div>;
  };

  return (
    <TableMobileContainer>
      {data.map((item, index) => (
        <TableRowContainer key={index} keyItem={index} length={data.length}>
          <TableCellContainerKey>{item.key}</TableCellContainerKey>
          <TableCellContainerValue>
            {renderValue(item.value, { transformValue: item.transformValue })}
          </TableCellContainerValue>
        </TableRowContainer>
      ))}
    </TableMobileContainer>
  );
};

export default TableMobile;
